import { isObservable, toJS } from "mobx";
import cloneDeep from "lodash/cloneDeep";
export function cloneDeepSafe(value) {
    if (isObservable(value)) {
        return toJS(value);
    }
    else {
        return cloneDeep(value);
    }
}
//# sourceMappingURL=index.js.map